import { inject, Injectable } from '@angular/core';

import { IntegrationsService } from '@app/modules/users/integrations.service';

@Injectable({
  providedIn: 'root'
})
export class IntegrationsState {
  private readonly integrationsService = inject(IntegrationsService);

  sendType(type: string) {
    return this.integrationsService.xplay(type);
  }
}